import React from 'react';
export function HeroSection() {
  return <section className="py-8" data-id="element-35">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-36">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-37">
          How To Gently Rewire Your Body Out Of Survival Mode — Without Reliving
          The Past
        </h1>
        <div className="mb-8" data-id="element-38">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/m7FdHiMYKEduzP7RTtRZ5z/Orange_And_Red_Modern_Minimalist_The_Most_Attractive_YouTube_Banner_%288%29.png" alt="Nervous system healing visualization" className="w-full rounded-lg aspect-[16/9] object-cover" data-id="element-39" />
        </div>
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8" data-id="element-40">
          <h2 className="text-xl md:text-2xl text-gray-600 italic max-w-2xl" data-id="element-41">
            Why more and more people are turning to body-based tools to finally
            feel safe again — and how you can start without revisiting old
            wounds
          </h2>
          <div className="text-green-600 font-medium md:text-right" data-id="element-42">
            Loved By 30,000+ Members
            <br data-id="element-43" />
            Worldwide
          </div>
        </div>
      </div>
    </section>;
}